import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Fuse from 'fuse.js';

//import ClusterMarker from './ClusterMarker';
import {
  getSegments,
  getOptions,
  changeMode,
} from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';
import constants, { ViewMode } from '../../constants';
import ProductOptions from './ProductOptions';
import MiniFindMyPartOptionsPsg from './MiniFindMyPartOptionsPsg';
import MiniFindMyPartOptionsGeneral from './MiniFindMyPartOptionsGeneral';
//import { } from './miniFindMyPartFunctions';

const MiniFindMyPartContainer = ({
  baseProductSystemId,
  selectedVariantId,
}) => {
  const miniFindMyPartRef = useRef();
  const [initBrandValue, setBrandValue] = useState({});
  const [initModelValue, setModelValue] = useState({});
  const [initYearValue, setYearValue] = useState({});

  const products = useSelector((state) => state.findMyPart.products);
  const searchItems = useSelector((state) => state.findMyPart.searchItems);
  const options = useSelector((state) => state.findMyPart.options);
  const resolvedVariant = useSelector(
    (state) => state.findMyPart.resolvedVariant
  );
  const dispatch = useDispatch();
  const [activeSegment, setActiveSegment] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [psgSearchItems, setPsgSearchItems] = useState(false);

  const toggleSegment = (segment) => {
    let newFilterList = [];
    setActiveSegment(segment);
  };
  // Decode all HTML entities using the browser's built-in HTML parser
  const decodeHtmlEntities = (str) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  };

  useEffect(() => {
    async function setup() {
      // Decode HTML entities in case URL was copied from HTML source (e.g., &amp; instead of &)
      const decodedSearch = decodeHtmlEntities(window.location.search);
      const urlParams = new URLSearchParams(decodedSearch);

      const variantSlug = urlParams.get('v');

      if (variantSlug) {
        // New ?v=slug format — send slug to backend for resolution
        const options = {
          baseProductSystemId,
          selectedVariantId,
          segment: null,
          optionsGeneral: null,
          optionsPsg: null,
          variantSlug,
        };
        dispatch(getOptions(options, false, true));
      } else {
        // Fall back to old ?brand=...&model=...&year=... params
        const urlBrand = { value: urlParams.get('brand') };
        setBrandValue(urlBrand);
        const urlModel = { value: urlParams.get('model') };
        setModelValue(urlModel);
        const urlYear = { value: urlParams.get('year') };
        setYearValue(urlYear);
        const options = {
          baseProductSystemId,
          selectedVariantId,
          segment: null,
          optionsGeneral: {
            brand: urlBrand,
            model: urlModel,
            year: urlYear,
          },
          optionsPsg: null,
        };
        dispatch(getOptions(options, false, true));
      }

      if (!mounted) {
        setMounted(true);
      }
    }
    setup();
  }, []);

  useEffect(() => {
    // When slug is resolved by backend, set dropdown init values
    if (resolvedVariant) {
      setBrandValue({ value: resolvedVariant.brand });
      setModelValue({ value: resolvedVariant.model });
      setYearValue({ value: resolvedVariant.year });
    }
  }, [resolvedVariant]);

  useEffect(() => {
    //dispatch(getSegments());
  }, [dispatch]);

  useEffect(() => {
    if (mounted) {
      setFilters();
    }
  }, [products]);

  useEffect(() => {
    if (searchItems?.length > 0) {
      setPsgSearchItems(
        new Fuse(searchItems, {
          keys: ['brand', 'model', 'year'],
          threshold: 0.3,
          distance: 10,
        })
      );
    }
  }, [searchItems]);
  if (!options) {
    return null;
  }
  return (
    <Fragment>
      <div className="row find-my-part__form-wrapper">
        <div className="small-12 medium-12 columns">
          {options && options.optionsPsg ? (
            <MiniFindMyPartOptionsPsg
              {...{ baseProductSystemId, selectedVariantId, psgSearchItems }}
            />
          ) : (
            <MiniFindMyPartOptionsGeneral
              {...{
                baseProductSystemId,
                initBrandValue,
                initModelValue,
                initYearValue,
                selectedVariantId,
              }}
            />
          )}
          <ProductOptions />
        </div>
      </div>
    </Fragment>
  );
};
export default React.memo(MiniFindMyPartContainer);
